import { SVGProps } from 'react';

export const PinterestIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1829_8657)">
        <path
          d="M15.9999 0C7.16337 0 0 7.16356 0 15.9999C0 22.7784 4.21719 28.5731 10.1692 30.9043C10.0292 29.6384 9.90287 27.6915 10.2247 26.3094C10.5154 25.0608 12.1009 18.3564 12.1009 18.3564C12.1009 18.3564 11.6222 17.3981 11.6222 15.9809C11.6222 13.7562 12.9117 12.0952 14.5174 12.0952C15.8823 12.0952 16.5418 13.1202 16.5418 14.3491C16.5418 15.7219 15.6678 17.7743 15.2166 19.6763C14.8398 21.2689 16.0153 22.5676 17.5859 22.5676C20.4299 22.5676 22.6157 19.5691 22.6157 15.2407C22.6157 11.4099 19.8629 8.73144 15.9325 8.73144C11.3799 8.73144 8.70769 12.1461 8.70769 15.6749C8.70769 17.0501 9.23738 18.5246 9.89844 19.3262C10.0291 19.4846 10.0483 19.6236 10.0094 19.7851C9.88787 20.2906 9.61806 21.3772 9.565 21.5996C9.49519 21.8925 9.33306 21.9547 9.02994 21.8136C7.03156 20.8834 5.78225 17.9619 5.78225 15.6152C5.78225 10.5681 9.44925 5.93306 16.354 5.93306C21.9044 5.93306 26.2178 9.888 26.2178 15.1737C26.2178 20.688 22.741 25.1257 17.9152 25.1257C16.2939 25.1257 14.7697 24.2834 14.2481 23.2886C14.2481 23.2886 13.4457 26.3434 13.2512 27.0921C12.8898 28.4819 11.9148 30.2239 11.2626 31.2864C12.7598 31.75 14.3506 31.9999 15.9999 31.9999C24.8367 31.9999 32.0001 24.8367 32.0001 15.9999C32.0001 7.16356 24.8367 0 15.9999 0Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1829_8657">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
